import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-silver"
}
const _hoisted_3 = {
  key: 1,
  class: "text-silver"
}
const _hoisted_4 = {
  key: 2,
  class: "blog-admin-table-wrap"
}
const _hoisted_5 = { class: "blog-admin-table" }
const _hoisted_6 = { class: "post-title" }
const _hoisted_7 = { class: "post-slug" }
const _hoisted_8 = { class: "text-silver" }
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 3,
  class: "d-flex align-items-center gap-3 mt-4"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "text-silver" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createBlock(_component_AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", {
          class: "text-white mb-0",
          style: {"font-weight":"800"}
        }, "Blog Posts", -1)),
        _createVNode(_component_RouterLink, {
          to: "/admin/blog/new",
          class: "btn"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "border-style" }, [
              _createElementVNode("i", { class: "ti ti-plus" }),
              _createTextVNode(" New Post")
            ], -1)
          ])),
          _: 1
        })
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading posts..."))
        : (_ctx.posts.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No posts yet. Create your first one."))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Title"),
                    _createElementVNode("th", null, "Status"),
                    _createElementVNode("th", null, "Published"),
                    _createElementVNode("th", null, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: post.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(post.title), 1),
                        _createElementVNode("span", _hoisted_7, "/blog/" + _toDisplayString(post.slug), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['status-badge', post.status])
                        }, _toDisplayString(post.status), 3)
                      ]),
                      _createElementVNode("td", _hoisted_8, _toDisplayString(post.published_at ? _ctx.formatDate(post.published_at) : '—'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_RouterLink, {
                            to: '/admin/blog/' + post.id,
                            class: "table-action-btn edit"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createElementVNode("i", { class: "ti ti-edit" }, null, -1),
                              _createTextVNode(" Edit ")
                            ])),
                            _: 2
                          }, 1032, ["to"]),
                          (post.status === 'published')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: '/blog/' + post.slug,
                                target: "_blank",
                                class: "table-action-btn view"
                              }, _cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "ti ti-external-link" }, null, -1),
                                _createTextVNode(" View ")
                              ]), 8, _hoisted_10))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "table-action-btn delete",
                            onClick: ($event: any) => (_ctx.deletePost(post))
                          }, [
                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ti ti-trash" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.pendingDeleteId === post.id ? ' Confirm?' : ''), 1)
                          ], 8, _hoisted_11)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
      (_ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn",
              disabled: _ctx.page === 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadPage(_ctx.page - 1)))
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("span", { class: "border-style" }, "Prev", -1)
            ]), 8, _hoisted_13),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.page) + " / " + _toDisplayString(_ctx.totalPages), 1),
            _createElementVNode("button", {
              class: "btn",
              disabled: _ctx.page === _ctx.totalPages,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadPage(_ctx.page + 1)))
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("span", { class: "border-style" }, "Next", -1)
            ]), 8, _hoisted_15)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}